import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Hospital } from "../../utils/dto/module/scheme.types";
interface HospitalSelectionState {
    selectedHospitals: Hospital[];
}

const initialState: HospitalSelectionState = {
    selectedHospitals: [],
};

const hospitalSelectionSlice = createSlice({
    name: "hospitalSelection",
    initialState,
    reducers: {
        selectHospital: (state, action: PayloadAction<Hospital>) => {
            if (!state.selectedHospitals.some(h => h.id === action.payload.id)) {
                state.selectedHospitals.push(action.payload);
            }
        },
        deselectHospital: (state, action: PayloadAction<number>) => {
            state.selectedHospitals = state.selectedHospitals.filter(h => h.id !== action.payload);
        },
        clearSelectedHospitals: (state) => {
            state.selectedHospitals = [];
        }
    }
});

export const { selectHospital, deselectHospital, clearSelectedHospitals } = hospitalSelectionSlice.actions;
export default hospitalSelectionSlice.reducer;
